// Campus photo for /colleges/stevens-institute-of-technology: CC0 1.0, by EvanSheppard, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AStevens_Lawns%2C_October_2023.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/stevens-institute-of-technology/; credited under the photo.
const photo = {
    "slug": "stevens-institute-of-technology",
    "alt": "Students on a sunny lawn among autumn trees and campus buildings at Stevens Institute of Technology in Hoboken",
    "src": "/colleges/stevens-institute-of-technology/campus-1600.webp",
    "srcSmall": "/colleges/stevens-institute-of-technology/campus-800.webp",
    "srcMid": "/colleges/stevens-institute-of-technology/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/stevens-institute-of-technology/og.jpg",
    "title": "Stevens Lawns, October 2023",
    "author": "EvanSheppard",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AStevens_Lawns%2C_October_2023.jpg",
    "read": "2026-10-02"
};

export default photo;
